import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  INote,
  INoteDetail,
  NoteType,
} from '@boma/supplier-portal/shared/entities';
import { NotesService } from '@boma/supplier-portal/shared/services';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'boma-note-create-component',
  templateUrl: './note-create-component.component.html',
  styleUrls: ['./note-create-component.component.scss'],
})
export class NoteCreateComponentComponent implements OnInit {
  noteFormGroup: FormGroup;
  creatingNote = false;

  notes: INoteDetail[] = [];

  formBuilder: any;
  @Input() notableId = null; // Have to pass in the GUID you want to link note to
  @Input() identifier = NoteType.Comment; // Pass in the type or the sub id.
  @Input() entityId = null;
  @Input() showTitle = false;

  @Output() notesResponse = new EventEmitter();

  constructor(private notesService: NotesService) {}

  ngOnInit(): void {
    this.noteFormGroup = new FormGroup({
      title: new FormControl(null),
      content: new FormControl(null, Validators.required),
      notableId: new FormControl(this.notableId, Validators.required),
      identifier: new FormControl(this.identifier),
    });
  }

  createNote() {
    console.log(this.noteFormGroup);
    if (!this.noteFormGroup.valid || !this.entityId) return;

    if (this.creatingNote) return;
    this.creatingNote = true;
    const note: INote = this.noteFormGroup.value;
    const notes: INote[] = [note];

    this.notesService
      .createNotes(this.entityId, notes)
      .pipe(
        finalize(() => {
          this.creatingNote = false;
        })
      )
      .subscribe(
        (x) => {
          this.notesResponse.emit(x);
          this.notes = [...this.notes, ...x];

          this.noteFormGroup.reset({
            title: '',
            content: '',
            notableId: this.notableId,
            identifier: this.identifier,
          });
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
